export default () => {
    
    document.querySelectorAll('.js--scroll-to').forEach((btn) => {

        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const sect = document.querySelector(btn.getAttribute('href'));

            window.scroll({
                top: sect.getBoundingClientRect().top + scrollY,
                behavior: 'smooth'
            });

        });

    });
    
}